import type { EmailFormSchema } from './schema';

export const defaultValues: Readonly<EmailFormSchema> = {
  id: -1,
  email: '',
  pivot: {
    default: 0,
  },
  intent: 'create',
  // using this to set change in form
  // to differentiate between create and update
  localMatchId: undefined,
  setDirtyHelper: false,
} as const;
